import React, { useEffect, useState } from "react";
import "react-router-dom";
import "@fortawesome/react-fontawesome";
import "./Navbar.css";

import { useAuth } from "../../../firebase/AuthProvider";
import HeaderComponent from "./HeaderComponent";
import SideBarComponent from "./SideBarComponent";

import { BrandLoader } from "../../ui/Logo/BrandLoader";

interface NavbarProps {
  toggleDarkMode: () => void;
  isDarkMode: boolean;
  canUseDarkMode: boolean;
  children?: React.ReactNode;
}





const Navbar: React.FC<NavbarProps> = ({
  toggleDarkMode,
  isDarkMode,
  canUseDarkMode,
  children,
}) => {
  const [isShowSidebarMobile, setIsShowSidebarMobile] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(() => {
    const savedState = localStorage.getItem("sidebarCollapsed");
    return savedState ? JSON.parse(savedState) : true;
  });

  // Automatically save to localStorage whenever the state changes
  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);
  const { currentUser, currentRoles } = useAuth();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (currentRoles) {
      setLoading(false);
    }
  }, [currentRoles]);

  const handleShowSidebar = () => {
    setIsShowSidebarMobile(true);
    console.log("HandleSidebar call");
  }

  const handleCloseSidebar = () => setIsShowSidebarMobile(false);

  return (
    <>
      {loading && <BrandLoader fullScreen />}
      {currentUser && currentRoles && (
        <>
          <SideBarComponent 
            isShowSidebarMobile={isShowSidebarMobile} 
            onToggleCollapse={setIsSidebarCollapsed} // Pass the state setter down
          />
          
          {isShowSidebarMobile && (
            <div onClick={handleCloseSidebar} className="sidebar_overlay"></div>
          )}
          
          {/* DYNAMIC MARGIN: Switches between 5rem and 18.75rem based on collapse state */}
          <div className={`main_content_wrapper ${isSidebarCollapsed ? "main_content_wrapper--sidebar-collapsed" : "main_content_wrapper--sidebar-expanded"} dark-page-canvas min-h-screen flex flex-col bg-white dark:bg-slate-950 transition-all duration-300 ease-in-out`}>
            <HeaderComponent
              handleShowSidebar={handleShowSidebar}
              canUseDarkMode={canUseDarkMode}
              isDarkMode={isDarkMode}
              onToggleDarkMode={toggleDarkMode}
            />
            <div className="main_content dark-page-canvas flex-1 flex flex-col flex-grow-1 bg-white dark:bg-slate-950 transition-colors">{children}</div>
          </div>
        </>
      )}
    </>
  );
};

export default Navbar;
